<script lang="ts">
    import {onMount} from "svelte";
    import PortalView from "../Portal/PortalView.svelte";
    import DialogView from "./DialogView.svelte";
    import {QrCodeDialogStore} from "../../../store/dialog/QrCodeDialogStore";
    import ImageView from "../Image/ImageView.svelte";
    import {QrCodeUtil} from "../../../lib/Common/QrCode/QrCodeUtil";

    $: qrCodeDialogStoreShowData = QrCodeDialogStore.showData;

    $: isShow = (() => {
        if ($qrCodeDialogStoreShowData == null) {
            return false;
        }
        return true;
    })();

    $: qrCodeImageUrl = (() => {
        if ($qrCodeDialogStoreShowData == null) {
            return null;
        }
        const qrCodeValue = $qrCodeDialogStoreShowData.qrCodeValue;
        const size = $qrCodeDialogStoreShowData.size;

        const qrCodeImageUrl = QrCodeUtil.createImageUrl(qrCodeValue, size);
        return qrCodeImageUrl;
    })();

    onMount(() => {
    });

    function onShow() {

    }

    function onClose() {
        QrCodeDialogStore.showData.set(null);
    }

</script>

<PortalView>
    <DialogView title="QR Code" isShow={isShow} on:show={onShow} on:close={onClose}>
        <div class="qr-code-dialog-content">
            {#if $qrCodeDialogStoreShowData != null}
                <div class="image">
                    <ImageView src={qrCodeImageUrl}/>

                </div>
                <div class="title">
                    { $qrCodeDialogStoreShowData.title }

                </div>
            {/if}
        </div>

    </DialogView>
</PortalView>


<style lang="scss">
    .qr-code-dialog-content {
        .title {
            text-align: center;
        }
    }
</style>